import { render, staticRenderFns } from "./watchRewardDetail.vue?vue&type=template&id=db9595aa&scoped=true&"
import script from "./watchRewardDetail.vue?vue&type=script&lang=js&"
export * from "./watchRewardDetail.vue?vue&type=script&lang=js&"
import style0 from "./watchRewardDetail.vue?vue&type=style&index=0&id=db9595aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9595aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db9595aa')) {
      api.createRecord('db9595aa', component.options)
    } else {
      api.reload('db9595aa', component.options)
    }
    module.hot.accept("./watchRewardDetail.vue?vue&type=template&id=db9595aa&scoped=true&", function () {
      api.rerender('db9595aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/playerDetails/components/watchRewardDetail.vue"
export default component.exports